// Font size computations in data form.

// Used to build a CSS file (scripts/makeFontSizeCSS.js) and compute font sizes in
// JS (src/core/util/ContainerSize.js), both done in terms of the non-office
// container size.

// Minimum font sizes
const MIN_FS = 17;
const HTML_MIN_FS = 11.5;

// Font size data in format {
//   className: [widthDivCoeff, minSize],
// } where final size is Math.max(containerWidth / widthDivCoeff, minSize).
module.exports = {
	errorIndicator: [85, HTML_MIN_FS],
	keyboard: [28, MIN_FS],
	keyboardLarge: [25, MIN_FS],
	keyboardWord: [55, HTML_MIN_FS],
	chapterBar: [45, MIN_FS],
	sliderMessage: [52, MIN_FS],
	levelBar: [50, MIN_FS],
	userInfo: [57, MIN_FS],
	canvas: [40, MIN_FS],
	solution: [60, MIN_FS],
	instructions: [60, MIN_FS],
	ruler: [40, MIN_FS * 1.5],
	bookMenu: [60, HTML_MIN_FS],
	teacherButton: [60, 15],
	buttonSmall: [60, MIN_FS],
	button: [50, MIN_FS],
	buttonLarge: [40, MIN_FS],
	heading: [40, MIN_FS + 2],
	blockTitle: [85, HTML_MIN_FS],
	blockTitleSmall: [95, HTML_MIN_FS],
	auxBlockTitle: [60, HTML_MIN_FS],
	labTypeBlurb: [75, HTML_MIN_FS],
	progressScore: [60, HTML_MIN_FS],
	problemProgressButton: [55, HTML_MIN_FS],
	problemStarProgressButton: [70, HTML_MIN_FS],
	profileName: [24, HTML_MIN_FS],
	profileUsername: [60, HTML_MIN_FS],
	profileCalendarMonth: [40, HTML_MIN_FS],
	profileCalendarDayNumber: [90, HTML_MIN_FS],
	profileHead: [47, HTML_MIN_FS],
	profileText: [55, HTML_MIN_FS],
	profileSmall: [80, HTML_MIN_FS],
	profileSmallPlus: [74, HTML_MIN_FS],
	settingsModalTitle: [30, HTML_MIN_FS + 4],
	settingsModalBottomSection: [60, HTML_MIN_FS],
	settingsModalTermsSection: [70, HTML_MIN_FS],
	settingsModalHeader: [45, HTML_MIN_FS + 2],
	settingsModalSubheader: [60, HTML_MIN_FS + 1],
	leaderboardsModalTitle: [25, HTML_MIN_FS + 4],
	leaderboardsModalMetric: [35, HTML_MIN_FS + 1],
	leaderboardsModalRow: [45, HTML_MIN_FS],
	leaderboardsAvatarModalUsername: [50, HTML_MIN_FS],
	messageModalTitle: [38, HTML_MIN_FS + 1],
	messageModal: [40, HTML_MIN_FS],
	gradeModalSection: [70, HTML_MIN_FS],
	bugReportButton: [45, HTML_MIN_FS],
	printableStudents: [70, HTML_MIN_FS],
	helpPrivacyTerms: [100, HTML_MIN_FS],
};
